<template>
  <div id="services">
    <h2 class="text-center">Our Services</h2>
    <div class="container">
      <div class="card hoverable">
        <div class="card-image">
          <img src="@/assets/pics/exercise-book.jpg" alt="sample" />
        </div>
      </div>
    </div>
    
    <div class="row" style="padding:0 30px">
      <div class="col s12">
        <div class="col s12 l5">
          <div class="card hoverable py-3 px-3">
          <p>
            <span class="text-center"><h4>Stationery</h4></span>
            We offers various stationery & equipment for customers to choose
            from. Any office stationery/equipment you desire kingdom already has
            you in mind. Our range of stationery/equipment is of high quality
            and at affordable prices with a one year guarantee for our
            equipment.
          </p>
          </div>
          <br />
          <div class="card hoverable py-3 px-3">
          <p>
            <span class="text-center"><h4>Printing</h4></span>
            Full-service printing for big and small businesses Speed matters in
            everything we do. We keep an eye on the clock, consistently
            accelerating our response times, reducing and eliminating dwell
            times, and delivering our products and services to you on your terms
            – on your schedule. With a capacity that measures in millions of
            pages or dozens of pallets of beautiful print per day, we are fast
            on really big projects. We produce high quality printing and
            packaging using specialty materials and processes that make your
            project stand out. Communication, understanding, and relationships
            with our customers are as important as the machinery that puts the
            ink on the paper. There’s nothing more rewarding than working with
            our customers to guide a project from concept to completion and
            along the way sharing a part of the print process that we love.
            Let’s discuss your next print project!
          </p>
          </div>
          <br />
          <div class="card hoverable py-3 px-3">
          <p>
            <span class="text-center"><h4>Digital Press Printing</h4></span>
            We print as per your requirements, from one piece up to a long run.
            We are more than capable of delivering a wide range of print
            solutions including:
          </p>
          
          <div class="row">
            <div class="col s12 px-5">
            <div class="col m6">
              <ul>
                <li>Invitation Cards</li>
                <li>Business Cards</li>
                <li>Brochures</li>
                <li>Tri & Quad fold Brochures</li>
              </ul>
            </div>
            <div class="col m6">
              <ul>
                <li>Posters</li>
                <li>Certificates</li>
                <li>Booklets</li>
                <li>Annual Reports</li>
              </ul>
            </div>
            </div>
          </div>
          </div>
        </div>
        <div class="col s12 l2"></div>
        <div class="col s12 l5">
          <div class="card hoverable py-3 px-3">
          <p>
            <span class="text-center"><h4>Large Format Print</h4></span>
            We can print banners and stickers up to 10 feet wide and forty-eight
            feet in length. The best part is that our expertise and quality in
            printing and our world-class customer service. The flexibility of
            our digital printing allows you to print a single large poster, or
            incorporate variable data on a larger run. We print on a wide range
            of materials that can accommodate long-term, outdoor use.
          </p>
          </div>
          <br />
          <div class="card hoverable py-3 px-3">
          <p>
            <span class="text-center"><h4>Graphic Design</h4></span>
            Our Graphic Design Department is well qualified to offer our
            customers full graphic design and typesetting services. We can
            answer any questions you may have or use our graphic design skills
            to bring your vision to life. We like keeping up with all of the
            current graphic design trends and concepts. We design:
          </p>

          <ul class="px-5">
            <li>Logo Design</li>
            <li>Label Design</li>
            <li>Posters/ Banners</li>
            <li>Stationery</li>
            <li>Promotional Displays</li>
          </ul>
          </div>
          <br />
          <div class="card hoverable py-3 px-3">
          <p>
            <span class="text-center"
              ><h4>Custom T-shirts/Polo Printing</h4></span
            >
            We take your t-shirt printing design ideas and turn them into
            customized t-shirts for all purposes.
          </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.card {
  border-radius: 5px;
}

h2,
h4 {
  text-decoration: underline;
  font-weight: 700;
}

p {
  font-family: "Times New Roman", Times, serif;
  font-size: 18px;
}

ul > li {
  list-style: disc !important;
  font-family: "Times New Roman", Times, serif;
  font-size: 18px;
}
</style>
